module.exports = __webpack_public_path__ + "media/images/icône liste-c61add660940061cfba2010ad2eb462c.svg";